"use strict";
// Param and result shapes for zigbee.* methods (defined in zigbee.ts); type aliases, so params fit RpcWireParams.
Object.defineProperty(exports, "__esModule", { value: true });
